import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
var formats = {
  ja_jp: {
    locale: 'ja-JP',
    code: 'JPY'
  },
  id_id: {
    locale: 'id-ID',
    code: 'IDR'
  }
};
export default (function (context, inject) {
  var plugin = {
    format: function format() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var symbol = this.symbol;
      var value = Number(amount);
      var locale = context.$auth.info.location.locale;
      var format = formats[locale];
      if (format) {
        var currencyFractionDigits = new Intl.NumberFormat(format.locale, {
          style: 'currency',
          currency: format.code
        }).resolvedOptions().maximumFractionDigits;
        var _number = value.toLocaleString(format.locale, {
          minimumFractionDigits: currencyFractionDigits
        });
        return "".concat(symbol).concat(_number);
      }
      var number = (value || 0).toFixed(2);
      var negative = number < 0;
      if (negative) {
        return "-".concat(symbol).concat(Math.abs(number));
      }
      return "".concat(symbol).concat(number);
    },
    get symbol() {
      return context.$auth.info.location.currencySymbol;
    }
  };
  inject('currency', plugin);
});